import { useState, useMemo } from "react";
import styles from "./styles.module.scss";
import WhitePlus from "@/assets/WhitePlus.svg";

export const Sectors = ({ items = [], className = "" }) => {
  const panels = useMemo(() => items.slice(0, 2), [items]);
  const [expanded, setExpanded] = useState(() => panels.map(() => false));

  const toggle = (i) =>
    setExpanded((prev) => {
      const next = [...prev];
      next[i] = !next[i];
      return next;
    });

  return (
    <section className={`${styles.wrapper} ${className}`}>
      {panels.map((item, i) => {
        const {
          headline,
          ctaText = "READ MORE",
          url = "#",
          image,
          roles = [],
          showMoreLabel = "SHOW MORE",
          sector = "",
        } = item || {};

        const visibleRoles = expanded[i] ? roles : roles.slice(0, 6);

        return (
          <article
            key={i}
            className={styles.card}
            data-sector={sector}
            style={{
              backgroundImage: `linear-gradient(180deg, rgba(0,96,117,0) 0%, rgba(0,34,42,0.70) 100%), url(${
                image?.url || ""
              })`,
            }}
            data-sourceflow-prop="items"
          >
            <div className={styles.flexGrow} />

            <div className={styles.topRow}>
              <h3
                className={styles.headline}
                data-sourceflow-prop="items.headline"
                dangerouslySetInnerHTML={{ __html: headline }}
              />
              <a
                className={styles.cta}
                href={url}
                data-sourceflow-prop="items.url"
                aria-label={typeof ctaText === "string" ? ctaText : "Read more"}
              >
                <span className={styles.ctaText} data-sourceflow-prop="items.ctaText">
                  {ctaText}
                </span>
                <WhitePlus aria-hidden="true" className={styles.squareIcon} />
              </a>
            </div>

            <div className={styles.spacer33} />

            <div className={styles.rolesBlock}>
              <div className={styles.rolesHeader}>
                <span className={styles.rolesTitle}>Typical Roles</span>

                {roles.length > 3 && (
                  <button type="button" className={styles.showMore} onClick={() => toggle(i)}>
                    <span className={styles.showMoreText} data-sourceflow-prop="items.showMoreLabel">
                      {showMoreLabel}
                    </span>
                    <WhitePlus aria-hidden="true" className={styles.squareIcon} />
                  </button>
                )}
              </div>

              <div className={styles.rolesChips}>
                {visibleRoles.map((r, idx) => (
                  <span key={idx} className={styles.chip} data-sourceflow-prop="items.roles">
                    {r.role}
                  </span>
                ))}
              </div>
            </div>
          </article>
        );
      })}
    </section>
  );
};

export default Sectors;
